import type { RadiusScale } from '@/theme/types'

export const radius: RadiusScale = {
  none: 0,
  sm: 4,
  md: 6,
  lg: 8,
  xl: 12,
  full: 9999,
}

